
export const common = {
  'call.us': 'Chiamaci',
  'privacy.policy': 'Informativa sulla privacy',
  'select.location': 'Seleziona la tua posizione',
  'location.description': 'Scegli la tua posizione per chiamare il numero appropriato',
  'usa': 'Stati Uniti',
  'non.usa': 'Non-USA Chiamata o WhatsApp',
  'documents.downloads': 'Documenti e download',
  'item': 'Articolo',
  'value': 'Valore',
  'price': 'Prezzo',
  'product': 'Prodotto',
  'msrp': 'Prezzo consigliato',
};
